import { useSelector } from 'react-redux';
import { useFavoriteStorage } from 'src/hooks/app';
import { useMemo } from 'react';
import { pathList } from 'src/route-list';
import { getSelectedPlacement } from 'src/store/requests/type-of-property/selector';

export const useComparePageLink = () => {
  const typeOfPropertySelector = useSelector(getSelectedPlacement);
  const { favIdsList } = useFavoriteStorage();

  const comparePageRouteLink = useMemo(() => {
    return `${pathList.compare}?types=${typeOfPropertySelector}&listIds=${favIdsList.join(',')}`;
  }, [pathList, typeOfPropertySelector, favIdsList]);

  return {
    comparePageRouteLink,
  };
};
